var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "padding-top": "5px" } }, [
    _vm.precision
      ? _c(
          "div",
          { staticClass: "c-box" },
          [
            _c("a-input-number", {
              staticClass: "input-number",
              attrs: {
                min: 0,
                disabled: _vm.disabled,
                formatter: _vm.formatter,
                parser: _vm.parser,
                placeholder: _vm.placeholder ? _vm.placeholder : "请输入...",
                precision: _vm.precision
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.innerValue,
                callback: function($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue"
              }
            }),
            _vm.addonAfter
              ? _c("div", { staticClass: "addonAfter" }, [
                  _vm._v(_vm._s(_vm.addonAfter))
                ])
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "c-box" },
          [
            _c("a-input-number", {
              staticClass: "input-number",
              attrs: {
                min: 0,
                disabled: _vm.disabled,
                formatter: _vm.formatter,
                parser: _vm.parser,
                placeholder: _vm.placeholder ? _vm.placeholder : "请输入..."
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.innerValue,
                callback: function($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue"
              }
            }),
            _vm.addonAfter
              ? _c("div", { staticClass: "addonAfter" }, [
                  _vm._v(_vm._s(_vm.addonAfter))
                ])
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }